import { Maybe } from '../../../__generated__/globalTypes'

import contactFragmentRawString from '../ContactFragment.graphql'

export const contactFragmentString = contactFragmentRawString

export type ContactFragment = {
  __typename: 'Contact'
  id: string
  firstName: string
  lastName: string
  address1: string
  address2: string
  company: string
  city: string
  state: string
  postalCode: string
  country: Maybe<string>
  primary: boolean
  birthday: Maybe<{
    day: number
    month: number
    year: Maybe<number>
  }>
  anniversary: Maybe<{
    day: number
    month: number
    year: Maybe<number>
  }>
}

export const isContactFragment = (fragment: any): fragment is ContactFragment =>
  fragment &&
  fragment.__typename === 'Contact' &&
  typeof fragment.id === 'string' &&
  typeof fragment.firstName === 'string' &&
  typeof fragment.lastName === 'string' &&
  typeof fragment.address1 === 'string' &&
  typeof fragment.address2 === 'string' &&
  typeof fragment.company === 'string' &&
  typeof fragment.city === 'string' &&
  typeof fragment.state === 'string' &&
  typeof fragment.postalCode === 'string' &&
  (fragment.country === null || typeof fragment.country === 'string') &&
  typeof fragment.primary === 'boolean' &&
  (fragment.birthday === null ||
    (fragment.birthday &&
      typeof fragment.birthday.day === 'number' &&
      typeof fragment.birthday.month === 'number' &&
      (fragment.birthday.year === null ||
        typeof fragment.birthday.year === 'number'))) &&
  (fragment.anniversary === null ||
    (fragment.anniversary &&
      typeof fragment.anniversary.day === 'number' &&
      typeof fragment.anniversary.month === 'number' &&
      (fragment.anniversary.year === null ||
        typeof fragment.anniversary.year === 'number')))
